import Icon from '../components/Icon.vue'

Icon.register({
  'chess-pawn': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M264 448H56S116 405.3 116 272H84C77.4 272 72 266.6 72 260V236C72 229.4 77.4 224 84 224H124.2C95.7 210.6 76 181.6 76 148 76 101.6 113.6 64 160 64S244 101.6 244 148C244 181.6 224.3 210.6 195.8 224H236C242.6 224 248 229.4 248 236V260C248 266.6 242.6 272 236 272H204C204 405.3 264 448 264 448zM292 464H28C21.4 464 16 469.4 16 476V500C16 506.6 21.4 512 28 512H292C298.6 512 304 506.6 304 500V476C304 469.4 298.6 464 292 464z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-pawn.js
// module id = HWy3
// module chunks = 144